import axios from "axios";

export default {
  namespaced: true,
  strict: true,
  state: {
    WorkSpaces: [],
    workspaceSelectionError: false,
  },
  getters: {
    getWorkSpaces(state) {
      return state.WorkSpaces;
    },
    getWorkSpaceURL() {
      return process.env.VUE_APP_workSpaceURL;
    },
    getWorkspaceSelectionError(state) {
      return state.workspaceSelectionError;
    },
    getWorkspaceIDKey() {
      return process.env.VUE_APP_workspaceIDQueryParam;
    },
  },
  mutations: {
    //to adjust root state, can alter method declaration, 3rd argument will be rootState
    setWorkSpaces(state, payload) {
      let newList = [];
      payload.workspaces.forEach((item) => {
        let isActive = false;
        let today = new Date();
        let startDate = Date.parse(item.startDate);
        let termDate = Date.parse(item.termDate);
        if (item.status != "Disabled" && startDate <= today < termDate) {
          isActive = true;
        }

        newList.push({
          id: item.id,
          displayName: item.displayName,
          status: item.status,
          tier: item.tier,
          maxUsers: item.maxUsers,
          startDate: item.startDate,
          termDate: item.termDate,
          isActive: isActive,
        });
      });
      //sort them
      newList.sort((a, b) => {
        return a.displayName.toLowerCase() > b.displayName.toLowerCase();
      });
      state.WorkSpaces = newList;
    },
    setWorkspaceSelectionError(state, payload) {
      state.workspaceSelectionError = payload;
    },
  },
  actions: {
    //to adjust root state, can alter method declaration, 3rd argument will be rootState
    async getWorkSpacesAsync(state) {
      //call GET on /workspaces
      try {
        await axios.get("workspaces").then((res) => {
          if (res.status == 200) {
            state.commit("setWorkSpaces", res.data);
          } else {
            state.commit("setWorkspaceSelectionError", true);
          }
        });
      } catch (err) {
        state.commit("setWorkspaceSelectionError", true);
      }
    },
    reset(state) {
      state.commit("setWorkspaceSelectionError", false);
      state.commit("setWorkSpaces", { workspaces: [] });
    },
  },
};
